import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";

import { i18nFilter } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import OnOffSwitchRegionalsContainer from "app/pages/website-analysis/geography/OnOffSwitchRegionalsContainer";
import { BannerTitle, StyledBanner } from "app/pages/website-analysis/geography/StyledComponents";

type Props = {
    toggleRegionals(isRegionalEnabled: boolean): void;
    isRegionalEnabled: boolean;
};

const RegionalsToggleBanner = ({ toggleRegionals, isRegionalEnabled }: Props) => {
    return (
        <StyledBanner
            title={
                <div>
                    <I18n
                        element={BannerTitle}
                        translatable={{ key: "website.analysis.regionals.toggle.banner.title" }}
                    />
                </div>
            }
            CustomIcon={
                <SWReactIcons
                    iconName={"regionals-world" as IconName}
                    size="sm"
                />
            }
            CustomButton={
                <OnOffSwitchRegionalsContainer
                    toggleRegionals={toggleRegionals}
                    isRegionalEnabled={isRegionalEnabled}
                    onOffSwitchLabel={i18nFilter()("website.analysis.regionals.toggle.label")}
                />
            }
        />
    );
};

export default RegionalsToggleBanner;
